import {keepPreviousData, queryOptions} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

import type {SavedViewsResponse} from '../components/views/types'

export const SAVED_VIEWS_QUERY_KEY = 'repo-saved-views'

export function savedViewsQueryOptions({owner, repo}: {owner: string; repo: string}) {
  return queryOptions({
    queryKey: [SAVED_VIEWS_QUERY_KEY, owner, repo] as const,
    placeholderData: keepPreviousData,
    queryFn: async ({signal}) => {
      const response = await verifiedFetchJSON(`/${owner}/${repo}/issues/views.json`, {signal})
      if (!response.ok) {
        let message = ''
        try {
          message = await response.text()
        } catch {
          // ignore — fall back to status code
        }
        throw new Error(message || `Failed to fetch saved views (${response.status})`)
      }
      return (await response.json()) as SavedViewsResponse
    },
  })
}
